export const route = {
  getComponent: (_, cb) => {
    import("./Marketplace").then(module => cb(null, module.default));
  },
  path: "marketplace"
};
